var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8878 7.5H6.0703C5.9555 7.5 5.85075 7.43448 5.80053 7.33124L3.82783 3.27603C3.70939 3.03256 3.9486 2.76916 4.20232 2.86367L7.03686 3.9195C7.15101 3.96202 7.27954 3.9313 7.36212 3.84175L9.30108 1.73916C9.41988 1.61032 9.62335 1.61032 9.74216 1.73916L11.6805 3.84113C11.7634 3.93099 11.8925 3.96159 12.0069 3.91848L14.7873 2.87062C15.0422 2.77458 15.2828 3.04045 15.1619 3.2845L13.1566 7.33316C13.106 7.43535 13.0018 7.5 12.8878 7.5Z",
    fill: "#FFCF24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50576 8.79497C7.89513 8.93624 8.09626 9.36642 7.95498 9.7558L5.88044 15.4736C5.60176 16.2416 4.50565 16.2125 4.26812 15.4308L2.53235 9.71804C2.41193 9.32171 2.63559 8.90281 3.03192 8.78239C3.42824 8.66197 3.84714 8.88564 3.96756 9.28196L5.13598 13.1275L6.54493 9.2442C6.6862 8.85482 7.11638 8.65369 7.50576 8.79497Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56018 8.75C9.97439 8.75 10.3102 9.08579 10.3102 9.5V15.5C10.3102 15.9142 9.97439 16.25 9.56018 16.25C9.14597 16.25 8.81018 15.9142 8.81018 15.5V9.5C8.81018 9.08579 9.14597 8.75 9.56018 8.75Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5289 8.75C12.9431 8.75 13.2789 9.08579 13.2789 9.5V15.5C13.2789 15.9142 12.9431 16.25 12.5289 16.25C12.1147 16.25 11.7789 15.9142 11.7789 15.5V9.5C11.7789 9.08579 12.1147 8.75 12.5289 8.75Z",
    fill: "#1F1F1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5273 8.75H14C15.3807 8.75 16.5 9.86929 16.5 11.25C16.5 12.6307 15.3807 13.75 14 13.75H13.25V12.25H14C14.5523 12.25 15 11.8023 15 11.25C15 10.6977 14.5523 10.25 14 10.25H12.5273V8.75Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.860c677311f6c913194cb643283b1b99.svg";
export { ForwardRef as ReactComponent };